import {PieChart, PieChartProps} from "../../chart/PieChart/PieChart";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightChartContainer, InsightChartContainerProps} from "../InsightChartContainer/InsightChartContainer";
import {PropsWithChildren} from "react";

export type InsightPieChartProps = Omit<InsightChartContainerProps, 'children'> & PieChartProps & {
  showTotal?: boolean
}

export const InsightPieChart = (props: PropsWithChildren<InsightPieChartProps>) => {
  const {
    id,
    data,
    tooltipPos,
    showTotal,
    children,
    ...rest
  } = props

  if (!data || data.length === 0) {
    return (
      <InsightEmpty {...rest} >
        {children}
      </InsightEmpty>
    )
  }

  return (
    <InsightChartContainer {...rest}>
      <PieChart id={id} data={data} tooltipPos={tooltipPos}/>
      {children}
    </InsightChartContainer>
  )
}
